import React, { useEffect, useState } from "react";
import moment from "moment";
import Search from "../../../../components/search";
import { useSelector } from "react-redux";
import Pagination from "../../../../components/tablePagination";
import { UpcomingHeaders, filterList } from "../data";
import CopyComponent from "../../../../components/copyComponent";
import Button from "../../../../components/button";
import {
  copyToClipboard,
  emptyAllSelectBox,
  getLink,
  session_id_beg,
  session_id_end,
} from "../../../../utils/helpers";
import ConfirmCancel from "../../../admin/appointments/subcomponents/cancelpopup";
import ReasonCancel from "../../../admin/appointments/subcomponents/reasonpopup";
import ConfirmCancelNotePopup from "../../../admin/appointments/subcomponents/confirmcancelpopup";
import Toggle from "../../../admin/appointments/subcomponents/toggle";
import ConfirmDeleteModal from "../../../../components/deleteConfirmModal";
import RefundDeleteModal from "../../../../components/refundConfirmModal";
import {
  confirmAppointmentstatus,
  getAppointmentsDetails,
} from "../../../../services/admin";
// import ReScheduleAppointment from "../../rescheduleappt";
import UpdatedReScheduleAppt from "../../updatedrescheduleappt";
import { toast } from "react-toastify";
import ConfirmReschedule from "../subcomponetnts/confirmreschedule";
import RescheduleAppointmentNotAllowModel from "../subcomponetnts/rescheduleAppointmentNotAllowModel";
import NoshowBox from "../../../admin/appointments/subcomponents/noshowbox";
import WorkerBox from "../../../admin/appointments/subcomponents/workersbox";
import {
  cancelGroupAppointments,
  noshowGroupAppointments,
  noshowRemoveGroupAppointments,
} from "../../../../services/medium";
import BackFillConfirmation from "../subcomponetnts/backfillconfirmation";
import { useNavigate, useSearchParams } from "react-router-dom";
import Contactpopup from "../subcomponetnts/contactpopup";
import FloatingActionMenu from "../subcomponetnts/floatingActionMenu";
import UpdatedReScheduleAppointment from "../subcomponetnts/updatedrescheduleappt";
import { TablePagination } from "@mui/material";
import { getAllCancellationReasons } from "../../../../services/medium";
import { set } from "date-fns";


export default function Upcoming(props) {
  const {
    blink,
    appointment_id,
    upcomingAppointments,
    changeHandler,
    onClickHandler,
    filterListAppointments,
    filterReset,
    getPaginationData,
    setFilterValues,
    setSearchValues,
    getAllAppointmentsList,
    activeTab,
    searchValue,
    filterValues,
    changeHandle1,
    setAppointments,
    goToMediumBackFill,
    refundingCallUpcomming,
    refundingCall,
    stopPaymentCall
  } = props;
  // const copyMeetingLink = (url) => {
  //   navigator.clipboard.writeText(url);
  // };
  // const handleChangeFilter = () =>{
  // console.log('ww')
  // }
  const { id } = useSelector((state) => state.user.user);
  const { id:curentUser } = useSelector((state) => state.user.user);
  const { allUpcomingCount } = useSelector((state) => state.medium);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [active, setActive] = useState({});
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [reschedeId, setReschedeId] = useState("");
  // anchor element of the open "..." actions menu (menu is rendered in a portal)
  const [menuAnchor, setMenuAnchor] = useState(null);
  // const [reschedeData, setReschedeData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState("");
  const [activeUser, setActiveUser] = useState();
  const [itemReschedule, setItemReschedule] = useState();
  const [indexReschedule, setIndexReschedule] = useState();
  const [messageNotAllow, setMessageNotAllow] = useState();
  const [appType, setAppType] = useState("");
  const [attendeesList, setattendeesList] = useState([]);

  const [noshowFrom, setNoShowFrom] = useState("");
  const [noShowActive, setNoShowActive] = useState();
  const [backFillId, setBackFillId] = useState("");
  const [activeContact, setactiveContact] = useState("");
  const [show, setShow] = useState(false);
  const [dataToDisplay, setDataToDisplay] = useState([]);
  const [appId, setId] = useState("");
  const [allAppointments, setAllAppointment] = useState("");
  const [isGroupSession, setIsGroupSession] = useState(false);
  const [reasons, setReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState("");
  const [isDenoted, setIsDenoted] = useState("");
  const [sessionTypeVal, setSessionType] = useState("");
  const [extraService, setExtraService] = useState(0);
  const [paymentStatus, setPaymentStatus] = useState("");
  const [selectedMedium, setSelectedMedium] = useState();
  const [isRefund, setIsRefund] = useState(0);
  // Refunding/waiving one attendee only patches that attendee's payment_status
  // inside the parent list's attendees[] (see patchPaymentStatus in
  // pages/medium/appointments/index.js) — the already-open NoshowBox modal
  // renders a separate `attendeesList` snapshot that patch doesn't touch, so
  // without a refetch the modal keeps showing the old status until the page
  // is reloaded. Track whether the in-flight refund/waive confirm targets an
  // attendee so confirmAppt/confirmApptNo can trigger the same
  // getAllAppointmentsList refresh the No Show/Remove attendee actions
  // already use, instead of relying on the local patch alone.
  const [isAttendeeAction, setIsAttendeeAction] = useState(false);


  useEffect(() => {

    const start = (page - 1) * rowsPerPage;
    const end = page * rowsPerPage;
    setDataToDisplay(upcomingAppointments.slice(start, end));
  }, [upcomingAppointments])
  const handleNoShow = (e, appoinment) => {
    setBackFillId(appoinment.id);
    setAppType(appoinment.session_type);
     setSelectedMedium(appoinment.medium_id)
    let value = e.target.value;
    let noShowBy = value;
    if(value === "refund"){
      setIsRefund(1);
      setIsAttendeeAction(false);
       window.loadModal2("#ConfirmRefundAppointmentFeedback", "show");
      // refundingCall(appoinment.medium_id, appoinment.id);
      return;
    }
     if(value === "stop_payment_request"){
      setIsRefund(0);
      setIsAttendeeAction(false);
       window.loadModal2("#ConfirmRefundAppointmentFeedback", "show");
      // stopPaymentCall(appoinment.medium_id, appoinment.id);
      return;
    }
    if (value === "me") {
      changeHandlerLocal(
        e,
        2,
        appoinment.appointmentId,
        // appoinment.medium_id,'
        id,
        "medium",
        "medium_id",
        appoinment.session_type,
        noShowBy
      );
      // changeHandler(
      //   e,
      //   2,
      //   appoinment.appointmentId,
      //   appoinment.medium_id,
      //   'medium',
      //   'medium_id',
      // );
    } else if (value === "ended-early") {
      changeHandlerLocal(
        e,
        4,
        appoinment.appointmentId,
        appoinment.medium_id,
        appoinment.session_type,
        noShowBy
        // appoinment.client_id,
        // 'medium',
        // 'client_id'
      );
    } else if (value === "restrict-client") {
      changeHandlerLocal(
        e,
        5,
        appoinment.appointmentId,
        appoinment.medium_id,
        appoinment.session_type,
        noShowBy
        // appoinment.client_id,
        // 'medium',
        // 'client_id'
      );
    } else if (value === "give-add-1") {
      changeHandlerLocal(
        e,
        6,
        appoinment.appointmentId,
        appoinment.medium_id,
        // appoinment.client_id,
        "medium",
        "medium_id",
        appoinment.session_type,
        noShowBy
        // 'client_id'
      );
    } else if (value === "other") {
      if (
        appoinment.session_type === "1" ||
        appoinment.session_type === "2" ||
        appoinment.session_type === "11" ||
        appoinment.session_type === "16" || 
        appoinment.session_type === "34"
      ) {
        if (parseInt(id) === parseInt(appoinment.medium_id)) {
          changeHandlerLocal(
            e,
            2,
            appoinment.appointmentId,
            appoinment.client_id,
            "medium",
            "client_id",
            appoinment.session_type,
            noShowBy
          );
        } else {
          changeHandlerLocal(
            e,
            2,
            appoinment.appointmentId,
            appoinment.medium_id,
            "medium",
            "client_id",
            appoinment.session_type,
            noShowBy
          );
        }
      } else {
        changeHandlerLocal(
          e,
          2,
          appoinment.appointmentId,
          appoinment.client_id,
          "medium",
          "client_id",
          appoinment.session_type,
          noShowBy
        );
      }
    }
  };

  const changeHandlerLocal = (
    e,
    type,
    id,
    targetId,
    targetType,
    targetTypeID,
    sessionType,
    noShowBy
  ) => {
    const updatedItems = upcomingAppointments.map((item) => {
      return { ...item, status: false };
    });
    setAppointments(updatedItems);
    setActive({
      e,
      type,
      id,
      targetId,
      targetType,
      targetTypeID,
      sessionType,
      noShowBy,
    });
    window.loadModal2("#ConfirmCancelupcomingmedium", "show");
  };
  const changeHandlerLocalCancel = (
    newtype,
    e,
    type,
    id,
    targetId,
    targetType,
    targetTypeID,
    sessionType,
    noShowBy,appoinment
  ) => {
    const updatedItems = upcomingAppointments.map((item) => {
      return { ...item, status: false };
    });
    setSessionType(appoinment.session_type);
    setExtraService(appoinment.is_extra_services);
    setPaymentStatus(appoinment.payment_status);
    setAppointments(updatedItems);
    setActive({
      e,
      type,
      id,
      targetId,
      targetType,
      targetTypeID,
      sessionType,
      noShowBy,
      appoinment
    });
     setIsDenoted("no");
    console.log("sessionType", newtype);
    if(newtype == 5){
    
      setSelectedReason("");
      setIsDenoted("yes");
    }
    //else{
     
    // }
    if(appoinment.medium_id == curentUser){
      window.loadModal2("#ConfirmCancelupcomingmediumAll", "show");
    }else{
      window.loadModal2("#ConfirmCancelupcomingmedium", "show");
    }   
  };

  const cancelRequest = () => {
    window.loadModal2("#ConfirmCancelupcomingmedium", "hide");
    window.loadModal2("#ReasonCancelupcomingmedium", "hide");
    window.loadModal2("#ConfirmCancelupcomingmediumAll", "hide");
    emptyAllSelectBox();
  };
  const confirmRequestnew = () => {
    
    let {
      e,
      type,
      id,
      targetId,
      targetType,
      targetTypeID,
      sessionType,
      noShowBy,
    } = active;
    setIsDenoted("no");
    if (isGroupSession) {
        cancelGroupAppointment(appId, allAppointments);
    }else{
      if (parseInt(appType) === 1 || parseInt(appType) === 2 || parseInt(appType) === 11 || parseInt(appType) === 16 || parseInt(appType) === 34) {
      changeHandle1(
        e,
        type,
        id,
        targetId,
        targetType,
        targetTypeID,
        sessionType,
        noShowBy
      );
    } else {
      changeHandler(
        e,
        type,
        id,
        targetId,
        targetType,
        targetTypeID,
        sessionType,
        noShowBy,
        selectedReason
      );
    }
    }
  }
  const confirmRequest = () => {
    let {
      e,
      type,
      id,
      targetId,
      targetType,
      targetTypeID,
      sessionType,
      noShowBy,
      appoinment
    } = active;
    // if(block != null){
    //   console.log(block,"BLOCK");
    // }
   
 
    if(isDenoted == "yes"){
      window.loadModal2("#ReasonCancelupcomingmedium", "show");
      return;
    }
    if (isGroupSession) {
        cancelGroupAppointment(appId, allAppointments);
    }else{
      if (parseInt(appType) === 1 || parseInt(appType) === 2 || parseInt(appType) === 11 || parseInt(appType) === 16) {
      changeHandle1(
        e,
        type,
        id,
        targetId,
        targetType,
        targetTypeID,
        sessionType,
        noShowBy
      );
    } else {
      
      if((sessionTypeVal == "8" || extraService == 1) && paymentStatus != "Refunding"){
       window.loadModal2("#ConfirmRefundAppointment", "show");
      return;
    }
      changeHandler(
        e,
        type,
        id,
        targetId,
        targetType,
        targetTypeID,
        sessionType,
        noShowBy,
        selectedReason
      );
    }
    }
    
  };

  const refreshScreen = () => {
    const data = {
      page: 1,
      rowsPerPage: 10,
    };
    getAllAppointmentsList(data, activeTab, "refresh");
  };
  const openConfirmAppointment = () => {
    window.loadModal2("#ConfirmAppointment", "show");
  };
  
  const confirmAppointment = () => {
    console.log(activeUser, "cwkdn");
    confirmAppointmentstatus(activeUser.appointmentId)
      .then((data) => {
        if (data.data.status) {
          toast.success("Status Confirmed", { position: "top-center" });
          const data = {
            page: 1,
            rowsPerPage: 10,
          };
          getAllAppointmentsList(data, activeTab);
        } else {
          toast.error("Something went wrong", { position: "top-center" });
        }
      })
      .catch(() => { });
  };
  const getTimeDiff = (appoinment) => {
    let appdate = moment(appoinment.date).format("YYYY/MM/DD");
    let now = moment().format();
    let datetimeB = moment(appdate + " " + appoinment.time);
    // console.log(appoinment.date,appoinment.time, "now",now)
    // console.log(datetimeB,"datetimeB")
    // var a = moment('2016-06-06T21:03:55');//now
    // var b = moment('2016-05-06T20:03:55');

    let final = datetimeB.diff(now, "minutes");
    // console.log(final)
    let status;
    final > -5 ? (status = true) : (status = false);
    return status;
  };

  const confirmRescheduleAppointmentpractice = (item, index) => {
    setItemReschedule(item);
    setIndexReschedule(index);
    window.loadModal2("#ConfirmRescheduleAppointmentpractice", "show");
  };

  const rescheduleAppointmentNotAllow = (item, index) => {
    let messageNotAllow = `We apologize but we do not allow rescheduling of appointments less than ${item.timeamount} before the start of a ${item.session_name}`;
    setMessageNotAllow(messageNotAllow);
    window.loadModal2("#RescheduleAppointmentNotAllowModel", "show");
  };
  const openReSchedulePopUp = () => {
    addQueryParams(itemReschedule.medium_id);
    let index = indexReschedule;
    let item = itemReschedule;
    console.log(index);
    console.log(item, "aaaa");
    // setAppointmentInfo
    setReschedeId(item);

    setSelectedIndex(index);
    if (parseInt(id) === parseInt(itemReschedule.client_id)) {
      setShow(true);
      window.loadModal2("#prvvvvv", "show");

    } else {
      window.loadModal2("#ReScheduleAppt", "show");
    }

    // let body = {
    //   appointment_id: item.id
    // }
    // getAppointmentsDetails(body).then((data) => {

    //   setReschedeData(data.data.data)
    //   setReschedeId(item)
    //   setSelectedIndex(index)
    //   window.loadModal2("#ReScheduleAppt", "show");
    // }).catch(() => { })
  };
  const addQueryParams = (id) => {
    const params = new URLSearchParams();
    params.append('id', id);

    navigate({
      pathname: '/appointments',
      search: params.toString(),
    });
  };
  const getTimeDiffTenMin = (appoinment, length) => {
    let appdate = moment(appoinment.date).format("YYYY/MM/DD");
    let now = moment().format();
    let datetimeB = moment(appdate + " " + appoinment.time);
    // console.log(appoinment.date,appoinment.time, "now",now)
    // console.log(datetimeB,"datetimeB")
    // var a = moment('2016-06-06T21:03:55');//now
    // var b = moment('2016-05-06T20:03:55');
let passed = moment(now).diff(datetimeB, "minutes");
    let final = datetimeB.diff(now, "minutes");
    // console.log(final)
    let status;
    let check = length == "16" ? final > -1 : final > -10;
    check ? (status = true) : (status = false);
     if (passed > 24) {
    return true; // disable
  }
    return status;
  };

  const checkIfAppointmentStarted = (appoinment) => {
    let appdate = moment(appoinment.date).format("YYYY/MM/DD");
    let now = moment().format();
    let datetimeB = moment(appdate + " " + appoinment.time);
    console.log(datetimeB, "datetimeB");
    var diff = datetimeB.diff(now, "seconds");
    var diffmin = datetimeB.diff(now, "minutes");
    console.log(diffmin, "diffmin");
    let status;
    console.log(diff, "diff");
    diff > 0 ? (status = true) : (status = false);
    return status;
  };
  const coptText = (value) => {
    copyToClipboard(value);
    toast.success("E-mail Copied", { position: "top-center" });
  };
  const openNoShowBox = (list, from, item) => {
     if (item.subsession_table_id === 101) {
      return;
    }
    setNoShowActive(item);
    setNoShowFrom(from);
    setattendeesList(list);
    window.loadModal("#NoshowBox", "show");
  };
  const openWorkerBox = (list, from, item) => {
    
    setNoShowActive(item);
    setNoShowFrom(from);
    setattendeesList(list);
    window.loadModal("#WorkerBox", "show");
  };

  const noshowGroupAppointment = (item) => {
    console.log(item);
    let body = {
      appointment_id: noShowActive.id,
      user_id: item.user_id,
    };
    noshowGroupAppointments(body).then((data) => {
      if (data.data.status) {
        toast.success("Status updated succesfully", {
          position: "top-center",
        });
        const data = {
          page: 1,
          rowsPerPage: 10,
        };
        getAllAppointmentsList(data, activeTab);
      } else {
        toast.error("Something went wrong", { position: "top-center" });
      }
    });
  };
  const noshowRemoveGroupAppointment = (item) => {
    console.log(item);
    let body = {
      appointment_id: noShowActive.id,
      user_id: item.user_id,
    };
    noshowRemoveGroupAppointments(body).then((data) => {
      if (data.data.status) {
        toast.success("Status updated succesfully", {
          position: "top-center",
        });
        const data = {
          page: 1,
          rowsPerPage: 10,
        };
        getAllAppointmentsList(data, activeTab);
      } else {
        toast.error("Something went wrong", { position: "top-center" });
      }
    });
  };
    const cancelGroupAppointmentPopup = (appointmentId, app) => {
      console.log(id," ",app.medium_id);
    
          setId(appointmentId);
          setAllAppointment(app);
          setIsGroupSession(true)
         
          if(app.medium_id == id){
            window.loadModal2("#ConfirmCancelupcomingmediumAll", "show");
          }else{
            window.loadModal2("#ConfirmCancelupcomingmedium", "show");
          }    
    }
  const cancelGroupAppointment = (id, app) => {
    const updatedItems = upcomingAppointments.map((item) => {
      return { ...item, status: false };
    });
    setAppointments(updatedItems);
    let attendee = app.attendees == undefined ? false : true;
    let body = {
      appointment_id: id,
    };
    cancelGroupAppointments(body, attendee).then((data) => {
      if (data.data.status) {
        toast.success("Status updated succesfully", {
          position: "top-center",
        });
        const data = {
          page: 1,
          rowsPerPage: 10,
        };
        getAllAppointmentsList(data, activeTab);
      } else {
        toast.error("Something went wrong", { position: "top-center" });
      }
    });
  };
  const checkAppId = (appoinment) => {
    if (appoinment.is_group_session === 0) {
      return appoinment.id;
    } else if (appoinment.is_group_session === 1) {
      
        if (appoinment.parent_id == null) {
          return appoinment.id;
        } else {
          return appoinment.parent_id;
        }
     
    } else {
      return appoinment.id;
    }
  };

  const openContactPopup = (item) => {
    window.loadModal2("#Contactpopup", "show");
    setactiveContact(item);
  };
  const handleChangePage = (
    event,
    newPage
  ) => {
    console.log(newPage, "event")
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (
    event
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };
  useEffect(() => {
    const start = (page - 1) * rowsPerPage;
    const end = page * rowsPerPage;
    setDataToDisplay(upcomingAppointments.slice(start, end));
  }, [page, rowsPerPage]);

  useEffect(() => {
    fetchReasons();
  }, []);

  const fetchReasons = async () => {
    try {
      const data = await getAllCancellationReasons();
      if (data && data.data && data.data.data) {
        const formatted = data.data.data.map((item) => ({
          id: item.id,
          value: item.reason,
        }));
        setReasons(formatted.length ? formatted : [{ id: null, value: "" }]);
        console.log(formatted, "cancellation reasons");
      }
    } catch (error) {
      console.error("Error fetching reasons:", error);
    }
  };
  var checkStatus0Values = function (data) {
  if (data && data.attendees && Array.isArray(data.attendees)) {
    return data.attendees.filter(function (info) {
      return info.status == 0;
    });
  }
  return [];
};

var checkWorkersValues = function (data) {
  if (data && data.workers && Array.isArray(data.workers)) {
    return data.workers.filter(function (info) {
      return info.status == 0;
    });
  }
  return [];
};
  const confirmRefundAppt = () => {
    window.loadModal2("#ConfirmRefundAppointment", "hide");
    let {
      e,
      type,
      id,
      targetId,
      targetType,
      targetTypeID,
      sessionType,
      noShowBy,
      appoinment
    } = active;

   
     changeHandler(
        e,
        type,
        id,
        targetId,
        targetType,
        targetTypeID,
        sessionType,
        noShowBy,
        selectedReason
      );
    
    refundingCallUpcomming(appoinment.medium_id, appoinment.id);
  };
   const confirmRefundNoAppt = () => {
    window.loadModal2("#ConfirmRefundAppointment", "hide");
    let {
      e,
      type,
      id,
      targetId,
      targetType,
      targetTypeID,
      sessionType,
      noShowBy,
      appoinment
    } = active;

   
     changeHandler(
        e,
        type,
        id,
        targetId,
        targetType,
        targetTypeID,
        sessionType,
        noShowBy,
        selectedReason
      );
    
   
  };
   // The master appointment lists get patched fine (patchPaymentStatus in
   // pages/medium/appointments/index.js), but the already-open NoshowBox
   // modal renders a separate `attendeesList` snapshot taken when it was
   // opened, which that patch never touches — so this also patches
   // attendeesList directly, which is what's actually on screen, instead of
   // depending on a refetch + the modal being reopened.
   const refreshAfterAttendeePayment = () => {
      setIsAttendeeAction(false);
      setattendeesList((prev) =>
        prev.map((attendee) =>
          attendee.id === backFillId
            ? { ...attendee, payment_status: "Refunding" }
            : attendee
        )
      );
    };
   const confirmAppt = () => {
      // goToMediumBackFill(backFillId, appType);
      // cancelRequest();
       window.loadModal2("#ConfirmRefundAppointmentFeedback", "hide");
      const onSuccess = isAttendeeAction ? refreshAfterAttendeePayment : undefined;
      if(isRefund){
        refundingCall(selectedMedium, backFillId,  false, onSuccess);
      } else {
        stopPaymentCall(selectedMedium, backFillId, false);
      }
    }
    const confirmApptNo = () => {
      // goToMediumBackFill(backFillId, appType);
      // cancelRequest();
      window.loadModal2("#ConfirmRefundAppointmentFeedback", "hide");
      const onSuccess = isAttendeeAction ? refreshAfterAttendeePayment : undefined;
      if(isRefund){
        refundingCall(selectedMedium, backFillId,  true, onSuccess);
      } else {
        stopPaymentCall(selectedMedium, backFillId, true);
      }
    }
    // Refund for one attendee inside a group session's attendee list
    // (NoshowBox). Each attendee is its own appointment row with its own
    // transaction, so this reuses the exact same confirm modal + call
    // function as the 1:1 row-level refund above — only the target
    // appointment id differs (the attendee's own id, not the group/host id).
    // No waive here: group sessions are pay-to-book, so there's no
    // outstanding/unpaid attendee state to waive.
    const refundAttendee = (item) => {
      setBackFillId(item.id);
      setSelectedMedium(item.medium_id);
      setIsRefund(1);
      setIsAttendeeAction(true);
      window.loadModal2("#ConfirmRefundAppointmentFeedback", "show");
    };
  return (
    <>

      <div className="table-box-medium admin-appoi" style={{ overflow: "visible" }}>
        <div className="appt-table-scroll" style={{ overflowX: "scroll", width: "100%" }}>
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              {React.Children.toArray(
                UpcomingHeaders.map((item) => <th>{item.title}</th>)
              )}
            </tr>
            {/* {dataToDisplay.length > 0 ? (
              dataToDisplay.map((appoinment, index) => ( */}
              {upcomingAppointments.length > 0 ? (
              upcomingAppointments.map((appoinment, index) => ( 
                <tr
                  className={`innr ${appoinment.is_worker_appointment == 1 ? "isWorkedBG" : "" } ${blink && parseInt(appointment_id) == parseInt(appoinment.id)
                    ? "alerts-border background-unset"
                    : ""
                    }`}
                >
                  {console.log(
                    parseInt(appointment_id),
                    parseInt(appoinment.id),
                    blink
                  )}
                  <td>
                    {session_id_beg + checkAppId(appoinment) + session_id_end}
                    {appoinment.give_add1_highlight ? (
                      <img
                        className="ml-1 star-app-hightlight"
                        src="../images/star.png"
                      />
                    ) : (
                      ""
                    )}
                  </td>
                  <td className="min-width-210">
                    {appoinment.meeting_link === "" ||
                      appoinment.meeting_link === null ||
                      appoinment.meeting_link === "NULL" ? (
                      <>
                        <span className="w-unset loading-regenrate">
                          {"Generating Zoom link"}
                        </span>
                        <img
                          title="Refresh"
                          onClick={(e) => refreshScreen("refresh")}
                          className="googl-link-copy-img copy-image-animate refresh-btn-app mt-4"
                          alt="copy"
                          src="images/refresh.png"
                        />
                      </>
                    ) : (
                      <div className="d-flex align-items-center">
                        <a
                          className={`pointer googl-link-new font-size-14 mr-3 d-inline-flex align-items-center justify-content-center learn-more-btn ${blink &&
                            parseInt(appointment_id) == parseInt(appoinment.id)
                            ? "alerts-border"
                            : ""
                            }`}
                          target="_blank"
                          href={appoinment.meeting_link}
                        >
                          Join
                        </a>
                        <div className="googl-link">
                          <a
                            href={appoinment.meeting_link}
                            target={"_blank"}
                            className="googl-link-new-1"
                          >
                            {appoinment.meeting_link
                              .substring(0, 20)
                              .concat("...")}
                          </a>
                          <CopyComponent value={appoinment.meeting_link} />
                        </div>
                      </div>
                    )}
                    {/* <a href={appoinment.meeting_link}>{appoinment.meeting_link.substring(0, 20).concat("...")}</a>
                        <CopyComponent value={appoinment.meeting_link} /> */}
                    {/* <Button
                      className={`resend-btn w-unset height-35 min-width-130px`}
                      title="Click Here"
                      status={0}
                      onClick={() => getLink(appoinment.appointmentId)}
                    /> */}
                    {/* <a
                      className="appointment-links"
                      href={appoinment.meeting_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {appoinment.meeting_link}
                    </a>
                    <img
                      onClick={() => copyMeetingLink(appoinment.meeting_link)}
                      className="googl-link-copy-img "
                      src="images/copy.png"
                      alt="copy"
                    /> */}
                  </td>
                  {getTimeDiff(appoinment)}
                  <td>
                    <div className="min-width-70px ">
                      <Toggle
                        openConfirmAppointment={openConfirmAppointment}
                        item={appoinment}
                        setActiveUser={setActiveUser}
                      />
                    </div>
                  </td>
                  <td>
                  {(appoinment.attendees == undefined && appoinment.workers == undefined )? (
                    <>
                      <span className="capitalize">
                        {appoinment.client_name},
                      </span>
                      <br />
                      <span className="capitalize">
                        {appoinment.medium_name}
                      </span>
                    </>
                  ) : (
                   <>
                      {appoinment &&
 Array.isArray(appoinment.attendees) &&
 appoinment.attendees.length > 0 && (
                        <span
                          className="text-underline pointer p-1"
                          onClick={() =>
                            openNoShowBox(appoinment.attendees, "remove", appoinment)
                          }
                        >
                          {checkStatus0Values(appoinment).length}&nbsp;Attendee(s)
                        </span>
                      )}

                      {appoinment && Array.isArray(appoinment.attendees) && appoinment.attendees.length > 0 &&
                      Array.isArray(appoinment.workers) && appoinment.workers.length > 0 && <br />}

                      {appoinment && Array.isArray(appoinment.workers) && appoinment.workers.length > 0 && (
                        <span
                          className="text-underline pointer p-1"
                          onClick={() =>
                            openWorkerBox(appoinment.workers, "remove", appoinment)
                          }
                        >
                          {checkWorkersValues(appoinment).length}&nbsp;Worker(s)
                        </span>
                      )}
                    </>
                  )}
                  </td>
                  <td>
                    <div style={{ fontWeight: '500' }}>{appoinment.date.split(" ")[0]}</div>
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '2px' }}>{appoinment.time}</div>
                  </td>
                  <td style={{ whiteSpace: "normal", wordBreak: "break-word", minWidth: 160, maxWidth: 220 }}>{appoinment.session_name}</td>
                  <td>
                    {appoinment.attendees == undefined && appoinment.subsession_table_id != 102 ?

                      <div className={`${appoinment.payment_status != null ? "color-d5a67b" : ""} d-flex align-items-center height-45`}>
                        {appoinment.payment_status != null && appoinment.payment_status != "NULL" ? (appoinment.payment_status) : 'N/A'}
                      </div>
                      :
                      'N/A'
                    }
                  </td>
                  <td>
                    {appoinment.attendees == undefined ?
                      <>
                        {/* This select only ever gets an actual option from one
                            of the two blocks below - when neither one's
                            condition is true (e.g. session_type "8" but
                            client_id === curentUser), it used to render as a
                            dropdown containing nothing but the disabled
                            "Select" placeholder - clickable-looking but with
                            no real choice in it. Folding both option
                            conditions into the outer check so that case
                            shows plain "N/A" instead of a dead dropdown. */}
                        {appoinment.is_group_session === 0 && (appoinment.session_type === "8" || appoinment.session_type === "7" || appoinment.is_extra_services == 1) &&
                          (((appoinment.session_type === "8" || appoinment.is_extra_services == 1) && appoinment.payment_status != "Refunding" && appoinment.client_id != curentUser) ||
                            (appoinment.session_type === "7" && appoinment.payment_status != "Refunding" && appoinment.payment_status != "Waived" && appoinment.client_id != curentUser)) ?
                          <select
                            // value={appoinment.statusValue}
                            onChange={(e) => handleNoShow(e, appoinment)}
                            className="appointment-select-box"
                          >
                            <option value="" selected disabled>
                              Select
                            </option>
                              {((appoinment.session_type === "8" || appoinment.is_extra_services == 1) && appoinment.payment_status != "Refunding" && appoinment.client_id != curentUser) && (
                              <>

                              <option value={"refund"}>{"Refunding"}</option>
                              </>
                            )}
                            {(appoinment.session_type === "7" && appoinment.payment_status != "Refunding" && appoinment.payment_status != "Waived" && appoinment.client_id != curentUser )&& (
                              <option
                                value={
                                  appoinment.payment_status === "Paid"
                                    ? "refund"
                                    : "stop_payment_request"
                                }
                              >
                                {appoinment.payment_status === "Paid"
                                  ? "Refunding"
                                  : "Stop Payment Request"}
                              </option>
                            )}




                          </select>
                          :
                          'N/A'
                        }
                      </>
                      :

                      'N/A'
                    }
                  </td>
                  <td>
                    {appoinment.attendees == undefined ? (
                      <>
                        {appoinment.is_group_session === 0 ? (
                          <select
                            // value={appoinment.statusValue}
                            onChange={(e) => handleNoShow(e, appoinment)}
                            className="appointment-select-box"
                          >
                            <option value="" selected disabled>
                              Select
                            </option>

                            {/* <option value={"me"}>{"No Show By Me"}</option> */}
                            <option
                              disabled={appoinment.noShowTimes}
                              value={"other"}
                            >

                              {appoinment.session_type === "1" ||
                                appoinment.session_type === "2" ||
                                appoinment.session_type === "11" ||
                                appoinment.session_type == "16" ||
                                appoinment.session_type == "7" ||
                                appoinment.session_type == "8"
                                ? "Other No show"
                                : "Client no-show"}
                            </option>
                            {(appoinment.session_type == "7" ||
                              appoinment.session_type == "8") && (appoinment.medium_id == parseInt(id)) &&
                              <option value={'mail'}> <a
                                href={"mailto:concerns@verysoul.com"}
                                target="_blank"
                                className="report-url"
                              >
                                Report
                              </a></option>
                            }
                            {appoinment.session_type !== "1" &&
                              appoinment.session_type !== "2" &&
                              appoinment.session_type !== "3" &&
                              appoinment.session_type !== "11" &&
                              appoinment.session_type !== "7" &&
                              appoinment.session_type !== "8" &&
                              (
                                <option
                                  disabled={getTimeDiffTenMin(
                                    appoinment,
                                    appoinment.session_type
                                  )}
                                  value={"ended-early"}
                                >
                                  {"Ended early"}
                                </option>
                              )}
                            {appoinment.session_type !== "1" &&
                              appoinment.session_type !== "2" &&
                              appoinment.session_type !== "3" &&
                              appoinment.session_type !== "11" &&
                              appoinment.session_type !== "16" &&
                              (appoinment.medium_id == curentUser) &&
                              (
                                <option value={"restrict-client"}>
                                  {"Restrict client"}
                                </option>
                              )}
                            {appoinment.session_type === "5" ? (
                              <option
                                disabled={appoinment.noShowTimes}
                                value={"give-add-1"}
                              >
                                {"Give Add’l"}
                              </option>

                            ) : (
                              ""
                            )}
                           
                            {/* {(appoinment.session_type === "8" && appoinment.payment_status != "Refunding") && (
                              <>
                              
                              <option value={"refund"}>{"Refunding"}</option>
                              </>
                            )} */}
                          </select>
                        ) : (
                          "N/A"
                        )}
                      </>
                    ) : (
                      <>
                        <Button
                          status={0}
                          onClick={() =>
                            openNoShowBox(appoinment.attendees, "", appoinment)
                          }
                          type="button"
                          className={`resend-btn w-130`}
                          title="No Show"
                        />
                      </>
                    )}
                  </td>
                  {/* <td>
                    <div>
                      <div className="d5a67b ml-1">
                        {appoinment.client_email}{" "}
                      </div>
                    </div>
                  </td> */}

                  <td className="dot-image">
                    <img
                      onClick={(e) => {
                        setMenuAnchor(appoinment.status ? null : e.currentTarget);
                        onClickHandler(e, appoinment.appointmentId, "upcoming");
                      }}
                      src="../images/Unionblck.png"
                      className="pointer dot-image-inside"
                      alt="dots"
                    />
                    {appoinment.status && (
                      <FloatingActionMenu anchorEl={menuAnchor} className="approve-btn-1 approve-btn">
                        <span className="w-100 anchor-white">
                          {
                            parseInt(id) === parseInt(appoinment.medium_id) &&
                            (appoinment.session_type === "7" ||
                              appoinment.session_type === "8")
                            || appoinment.session_type === "12"
                            || appoinment.session_type === "13"
                            || appoinment.session_type === "14"
                            ? (
                              <a
                                onClick={() => openContactPopup(appoinment)}
                                href={`javascript:void();`}
                              >
                                Contact
                              </a>
                            ) : (
                              <a
                                onClick={() =>
                                  coptText(
                                    (appoinment.session_type === "1" ||
                                      appoinment.session_type === "2" ||
                                      appoinment.session_type === "11" ||
                                      appoinment.session_type === "16" ||
                                      appoinment.session_type === "7" ||
                                      appoinment.session_type === "8") &&
                                      parseInt(id) ===
                                      parseInt(appoinment.client_id)
                                      ? appoinment.medium_email
                                      : appoinment.client_email
                                  )
                                }
                                href={`mailto:${(appoinment.session_type === "1" ||
                                  appoinment.session_type === "2" ||
                                  appoinment.session_type === "11" ||
                                  appoinment.session_type === "16" ||
                                  appoinment.session_type === "7" ||
                                  appoinment.session_type === "8") &&
                                  parseInt(id) === parseInt(appoinment.client_id)
                                  ? appoinment.medium_email
                                  : appoinment.client_email
                                  }`}
                              >
                                Contact
                              </a>
                            )}
                        </span>
                        {appoinment.session_type == "16" ? (
                          <span
                            className="w-100"
                            onClick={(e) => {
                              changeHandlerLocalCancel(
                                appoinment.session_type,
                                e,
                                3,
                                appoinment.appointmentId,
                                id,"","","","",appoinment
                              );
                              setIsGroupSession(false);
                              // changeHandler(
                              //   e,
                              //   3,
                              //   appoinment.appointmentId,
                              //   appoinment.medium_id
                              // );
                            }}
                          >
                            Cancel
                          </span>
                        ) : (
                          checkIfAppointmentStarted(appoinment) && (
                            <>
                              {appoinment.is_group_session == 0 ? (
                                <span
                                  className="w-100"
                                  onClick={(e) => {
                                    changeHandlerLocalCancel(
                                      appoinment.session_type,
                                      e,
                                      3,
                                      appoinment.appointmentId,
                                      id,"","","","",appoinment
                                    );
                                    setIsGroupSession(false);
                                    // changeHandler(
                                    //   e,
                                    //   3,
                                    //   appoinment.appointmentId,
                                    //   appoinment.medium_id
                                    // );
                                  }}
                                >
                                  Cancel
                                </span>
                              ) : (
                                <span
                                  className="w-100"
                                  onClick={(e) =>
                                    cancelGroupAppointmentPopup(
                                      appoinment.id,
                                      appoinment
                                    )
                                  }
                                // changeHandler(
                                //   e,
                                //   3,
                                //   appoinment.appointmentId,
                                //   appoinment.medium_id
                                // );
                                >
                                  Cancel
                                </span>
                              )}
                            </>
                          )
                        )}

                        {appoinment.is_reschedule == 1 &&
                          appoinment.show_reschedule == 1  && appoinment.session_type != 3? (
                          <span
                            className="w-100"
                            onClick={() =>
                              confirmRescheduleAppointmentpractice(
                                appoinment,
                                index
                              )
                            }
                          >
                            Reschedule
                          </span>
                        ) : appoinment.is_reschedule == 0 &&
                          appoinment.show_reschedule == 1 ? (
                          <span
                            className="w-100"
                            onClick={() =>
                              rescheduleAppointmentNotAllow(appoinment, index)
                            }
                          >
                            Reschedule
                          </span>
                        ) : (
                          ""
                        )}
                      </FloatingActionMenu>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={20} style={{ padding: '48px 0', textAlign: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="4" stroke="#d5a67b" strokeWidth="1.5"/>
                      <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="#d5a67b" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <p style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#485257' }}>No Appointments Found</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {/* <div className="pagination-box">
          <div className="left-pagi">
            <span>Showing 1 to 10 of 18 entries</span>
          </div>
          <div className="right-pagi">
            <ul>
              <li>Previous</li>
              <li className="active">
                <a href="#">1</a>
              </li>
              <li>
                <a href="#">2</a>
              </li>
              <li>
                <a href="#">3</a>
              </li>
              <li>Next</li>
            </ul>
          </div>
        </div> */}
                </div>
        <Pagination
          rowsPerPageOptions={[5, 10, 25]}
          activeTab={"mediumupcoming"}
          count={allUpcomingCount}
          getPaginationData={getPaginationData}
        />

        {/* {upcomingAppointments.length > 0 && <TablePagination
          component="div"
          rowsPerPageOptions={[5, 10, 15, 20]}
          count={upcomingAppointments.length}
          page={page - 1}
          //  labelDisplayedRows={labelDisplayedRows}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />} */}
        <ConfirmCancelNotePopup
          deleteUser={confirmRequest}
          cancelRequest={cancelRequest}
           active={active}
          id={"ConfirmCancelupcomingmediumAll"}
        />
        <ConfirmCancel
          deleteUser={confirmRequest}
          cancelRequest={cancelRequest}
          id={"ConfirmCancelupcomingmedium"}
        />
        <ReasonCancel
          deleteUser={confirmRequestnew}
          cancelRequest={cancelRequest}
          reasons={reasons}                  // pass data as prop
        selectedReason={selectedReason}    // pass selected value
        setSelectedReason={setSelectedReason}
          id={"ReasonCancelupcomingmedium"}
        />
        
        <ConfirmDeleteModal
          deleteUser={confirmAppointment}
          id={"ConfirmAppointment"}
          label={"Are you sure ?"}
          btnLabel={"Continue"}
        />
        <RefundDeleteModal
          deleteUser={confirmRefundAppt}
          cancelRequest={confirmRefundNoAppt}
          id={"ConfirmRefundAppointment"}
          label={"Will a refund be issued for this cancellation?"}
          btnLabel={"Continue"}
        />
        <RefundDeleteModal
                        deleteUser={confirmAppt}
                        cancelRequest={confirmApptNo}
                        id={"ConfirmRefundAppointmentFeedback"}
                        label={"Should client still receive feedback survey?"}
                        btnLabel={"Continue"}
                      />
        <ConfirmReschedule
          deleteUser={openReSchedulePopUp}
          setIndexReschedule={indexReschedule}
          setItemReschedule={itemReschedule}
          id={"ConfirmRescheduleAppointmentpractice"}
          label={
            "Please confirm that you have permission from your partner/client to schedule at this time?"
          }
          btnLabel={"Continue"}
        />
        <RescheduleAppointmentNotAllowModel
          setIndexReschedule={indexReschedule}
          setItemReschedule={itemReschedule}
          id={"RescheduleAppointmentNotAllowModel"}
          label={messageNotAllow}
          btnLabel={"Continue"}
        />

        <UpdatedReScheduleAppt
          // usersListMedium={usersListMedium}
          // usersListClient={usersListClient}
          reschedeId={reschedeId}
          // reschedeData={reschedeData}
          getAllAppointmentsList={getAllAppointmentsList}
          activeTab={activeTab}
          setReschedeId={setReschedeId}
          // setReschedeData={setReschedeData}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
        />


        <NoshowBox
          noShowActive={noShowActive}
          list={attendeesList}
          noShowRequest={noshowGroupAppointment}
          noshowRemoveGroupAppointment={noshowRemoveGroupAppointment}
          noshowFrom={noshowFrom}
          refundAttendee={refundAttendee}
        />
        <WorkerBox
          noShowActive={noShowActive}
          list={attendeesList}
          noShowRequest={noshowGroupAppointment}
          noshowRemoveGroupAppointment={noshowRemoveGroupAppointment}
          noshowFrom={noshowFrom}
        />
        
        <BackFillConfirmation
          cancelRequest={() =>
            window.loadModal2("#BackFillConfirmation", "hide")
          }
          deleteUser={() => {
            window.loadModal2("#BackFillConfirmation", "hide");
            goToMediumBackFill(backFillId);
          }}
          id={"BackFillConfirmation"}
        />
        <Contactpopup activeContact={activeContact} />
      </div>
      <UpdatedReScheduleAppointment
        // usersListMedium={usersListMedium}
        // usersListClient={usersListClient}
        reschedeId={reschedeId}
        reschedeData={[]}
        getAllAppointmentsList={getAllAppointmentsList}
        activeTab={activeTab}
        setReschedeId={setReschedeId}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        show={show}
        setShow={setShow}
      />
    </>
  );
}
